import React from 'react';
import { Redirect } from 'react-router';
import _ from 'underscore';

import { Filter } from '~commonInfra/utils/Filter';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { RouterError } from '../../bootstrap/routerHelpers/RouterError';
import { Favorites } from '../../favorites/resources/Favorites';
import { IDataRoleInfo } from '../models/IDataRoleInfo';
import { DataRoles } from '../resources/Dataroles';

export interface RedirectToFavoritedDataRoleProviderProps {
  readonly roleId: string;
  readonly urls: SpacesSiteUrls;
}

export interface RedirectToFavoritedDataRoleProviderState {
  readonly roleExists: boolean;
  readonly hasError: boolean;
}

const InitialState: RedirectToFavoritedDataRoleProviderState = {
  roleExists: false,
  hasError: false
};

export class RedirectToFavoritedDataRoleProvider extends React.PureComponent<RedirectToFavoritedDataRoleProviderProps, RedirectToFavoritedDataRoleProviderState> {
  private unmounted: boolean = false;

  public constructor(props: RedirectToFavoritedDataRoleProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return <RouterError errorType={'datarole-removed-favorite'} urls={this.props.urls} />;
    } else if (this.state.roleExists) {
      return <Redirect to={this.props.urls.dataRolePath(this.props.roleId)} />;
    }

    return null;
  }

  public async componentDidMount() {
    if (_.isUndefined(this.props.roleId)) {
      this.setToErrorStateAndRemoveFromFavorites();
      return;
    }

    try {
      const dataRole: IDataRoleInfo = await DataRoles.all()
        .withFilters([Filter.fieldEq('id', this.props.roleId)])
        .getFirst();

      if (dataRole) {
        this.updateState({ roleExists: true });
      } else {
        this.setToErrorStateAndRemoveFromFavorites();
      }

    } catch (e) {
      this.setToErrorStateAndRemoveFromFavorites();
    }
  }

  private setToErrorStateAndRemoveFromFavorites() {
    Favorites.remove(this.props.roleId, 'dataRole');
    this.updateState({ hasError: true });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof RedirectToFavoritedDataRoleProviderState>(newState: Pick<RedirectToFavoritedDataRoleProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
